export default __webpack_public_path__ + "static/production3r-e23a0d678a44c3b5469d4529c392033f.jpg";